<template>
  <div>
    <modify-details
      :form="form"
      :residents="residents"
      @updated="$emit('updated')"
    />
    <div class="card">
      <div
        class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 back-ground-grey"
      >
        <div class="row">
          <div
            class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pt-0 pb-0 check-text-center"
          >
            <h5 class="mb-0 pt-1">CONFIGURAÇÕES</h5>
          </div>

          <div
            class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pt-0 pb-0 check-text-right"
          >
            <v-btn
              :disabled="reorder_mode"
              small
              class="btn-edit m-1"
              @click="$bvModal.show('modify_details')"
            >
              <i class="fas fa-pencil-alt mr-2 text-twenty" /> EDITAR
            </v-btn>
          </div>
        </div>

        <div class="row justify-content-center align-items-center">
          <div class="col-12 d-flex gap-4 flex-wrap justify-content-center">
            <div class="switch-section mr-2">
              <div class="switch-header">
                <i class="fas fa-copy mr-2"></i>
                <span class="switch-title"
                  >Copiar respostas de formulários anteriores</span
                >
              </div>
              <div class="switch-content">
                <label class="switch-modern">
                  <input
                    type="checkbox"
                    v-model="form.can_copy"
                    :disabled="loading"
                    @change="updateCanCopy()"
                  />
                  <span class="slider-modern">
                    <span class="slider-thumb">
                      <i class="fas fa-check thumb-icon"></i>
                    </span>
                  </span>
                </label>
              </div>
            </div>

            <div class="switch-section mr-2">
              <div class="switch-header">
                <i class="fas fa-user-check mr-2"></i>
                <span class="switch-title">Validar Responsável técnico</span>
              </div>
              <div class="switch-content">
                <label class="switch-modern">
                  <input
                    type="checkbox"
                    v-model="form.rt_validate"
                    :disabled="loading"
                    @change="updateValidateTechnicalManager()"
                  />
                  <span class="slider-modern">
                    <span class="slider-thumb">
                      <i class="fas fa-check thumb-icon"></i>
                    </span>
                  </span>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
        <h6 class="worksansr">
          DESCRIÇÃO: <strong>{{ form.description }}</strong>
        </h6>
        <h6 class="mb-0 worksansr">
          STATUS: <strong>{{ form.status_name }}</strong>
        </h6>
        <div class="row">
          <!-- perfis -->
          <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
            <h6 class="upper-text color-blue">Perfis</h6>
            <div class="row" v-if="public_answer && public_read && public_edit">
              <div class="col-xl-6 pt-0 pb-0">
                <h6 class="mb-0 worksansr upper-text">todos os perfis</h6>
              </div>
              <div class="col-xl-6 pt-0 pb-0">
                <b-badge variant="success" class="mr-1"> RESPONDER </b-badge>
                <b-badge variant="secondary" class="mr-1">
                  VER RESPONDIDOS
                </b-badge>
                <b-badge variant="info" class="mr-1"> EDITAR </b-badge>
              </div>
            </div>
            <hr
              v-if="public_answer && public_read && public_edit"
              class="mb-1 mt-0"
            />
            <v-data-iterator
              v-if="!public_answer || !public_read || !public_edit"
              must-sort
              sort-by="name"
              :sort-desc="false"
              :items="form.profiles"
              :items-per-page="5"
              :hide-default-footer="form.profiles.length <= 5"
            >
              <template v-slot:item="{ item }">
                <div class="row">
                  <div class="col-xl-6 pt-0 pb-0">
                    <h6 class="mb-1 upper-text worksansr">
                      {{ item.name }}
                    </h6>
                  </div>
                  <div class="col-xl-6 pt-0 pb-0">
                    <b-badge
                      v-if="item.answer || public_answer"
                      variant="success"
                      class="mr-1"
                    >
                      RESPONDER
                    </b-badge>
                    <b-badge
                      v-if="item.read || public_read"
                      variant="secondary"
                      class="mr-1"
                    >
                      VER RESPONDIDOS
                    </b-badge>
                    <b-badge v-if="item.edit || public_edit" variant="info">
                      EDITAR
                    </b-badge>
                  </div>
                </div>
                <hr class="mb-1 mt-0" />
              </template>
            </v-data-iterator>
          </div>
          <!-- grau de dependência ou público -->
          <div
            v-if="
              form.visibility_type_value === 'DEGREE_OF_DEPENDENCE' ||
              form.visibility_type_value === 'PUBLIC'
            "
            class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12"
          >
            <!-- grau de dependência -->
            <template
              v-if="form.visibility_type_value === 'DEGREE_OF_DEPENDENCE'"
            >
              <h6 class="upper-text color-blue">Graus de dependência</h6>
              <h6 class="worksansr">
                Disponível para os seguintes graus de dependência:
              </h6>
              <v-data-iterator
                must-sort
                sort-by="name"
                :sort-desc="false"
                :items="form.degrees_of_dependence"
                :items-per-page="5"
                :hide-default-footer="form.degrees_of_dependence.length <= 5"
              >
                <template v-slot:default="{ items }">
                  <div v-for="item in items" :key="item.id">
                    <h6 class="mb-1 upper-text worksansr">
                      {{ item.name }}
                    </h6>
                    <hr class="mt-0 mb-1" />
                  </div>
                </template>
              </v-data-iterator>
            </template>

            <template v-if="form.visibility_type_value === 'PUBLIC'">
              <h6 class="upper-text color-blue">PÚBLICO</h6>
              <h6 class="worksansr">Disponível para todos os residentes.</h6>
            </template>

            <template v-if="form.ignored_residents.length > 0">
              <h6 class="upper-text color-blue">EXCETO PARA</h6>
              <v-data-iterator
                must-sort
                sort-by="name"
                :sort-desc="false"
                :items="form.ignored_residents"
                :items-per-page="5"
                :hide-default-footer="form.ignored_residents.length <= 5"
              >
                <template v-slot:default="{ items }">
                  <div v-for="item in items" :key="item.id">
                    <h6 class="mb-1 upper-text worksansr">
                      {{
                        residents.find((resident) => resident.id === item).name
                      }}
                    </h6>
                    <hr class="mt-0 mb-1" />
                  </div>
                </template>
              </v-data-iterator>
            </template>
          </div>
          <!-- manual -->
          <div
            v-if="form.visibility_type_value === 'MANUAL'"
            class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12"
          >
            <h6 class="upper-text color-blue">Residentes</h6>
            <v-data-iterator
              must-sort
              sort-by="name"
              :sort-desc="false"
              :items="form.residents"
              :items-per-page="5"
              :hide-default-footer="form.residents.length <= 5"
            >
              <template v-slot:default="{ items }">
                <div v-for="item in items" :key="item.id">
                  <h6 class="mb-1 upper-text worksansr">
                    {{ item.name }}
                  </h6>
                  <hr class="mt-0 mb-1" />
                </div>
              </template>
            </v-data-iterator>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ModifyDetails from "./ModifyDetails.vue";

import api from "../../services/api";

import toast from "../../lib/ToastNotification";

export default {
  name: "FormDetails",

  components: {
    ModifyDetails,
  },

  props: {
    /** @type {{
     *    name: string,
     *    description: string,
     *    rest_home_id: number,
     *    id: number,
     *    semiology_form_status_id: number,
     *    status_name: ("ABERTO"|"DISPONÍVEL"|"DESATIVADO"),
     *    status_value: ("OPEN"|"AVAILABLE"|"INACTIVE"),
     *    created_at: Date,
     *    updated_at: Date,
     *    profiles: {
     *      id: number,
     *      name: string,
     *      answer: boolean,
     *      read: boolean,
     *      edit: boolean,
     *    }[],
     *    degrees_of_dependence: { id: number, name: string, value: number }[],
     *    residents: { id: number, name: string }[],
     *  }} formulário
     */
    form: Object,
    residents: Array,
    reorder_mode: Boolean,
  },

  data() {
    return {
      loading: false,
      public_answer: false,
      public_read: false,
      public_edit: false,
    };
  },

  watch: {
    form: async function () {
      this.public_answer = this.form.profiles.every(
        (profile) => !profile.answer
      );
      this.public_read = this.form.profiles.every((profile) => !profile.read);
      this.public_edit = this.form.profiles.every((profile) => !profile.edit);
    },
  },

  methods: {
    async evOnModifyDetailsUpdated() {
      this.$emit("updated");
    },

    async updateValidateTechnicalManager() {
      try {
        this.loading = true;

        let id = this.form.id;

        let rt_validate = this.form.rt_validate;

        let params = { id, rt_validate };

        const response = await api.put(
          "/rest-home/semiology/form/validate-technical-manager",
          params
        );

        const { error, message } = response.data;

        if (!error) {
          toast(message, "success");
        } else {
          toast(message, "error");
        }

        this.loading = false;
      } catch (error) {
        this.loading = false;

        console.error(error);
      }
    },

    async updateCanCopy() {
      try {
        this.loading = true;

        let id = this.form.id;

        let can_copy = this.form.can_copy;

        let params = { id, can_copy };

        const response = await api.put(
          "/rest-home/semiology/form/can-copy",
          params
        );

        const { error, message } = response.data;

        if (!error) {
          toast(message, "success");
        } else {
          toast(message, "error");
        }

        this.loading = false;
      } catch (error) {
        this.loading = false;

        console.error(error);
      }
    },
  },
};
</script>

<style scoped>
/* Modern Switch Section Styling */
.switch-section {
  background: #f8fafc;
  border-radius: 12px;
  border: 1.5px solid #e5e7eb;
  min-width: 280px;
  padding: 20px 20px 16px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  transition: border-color 0.3s;
}

.switch-title {
  font-size: 15px;
}

.switch-content {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}

.switch-modern {
  position: relative;
  display: inline-block;
  width: 54px;
  height: 28px;
  cursor: pointer;
}

.switch-modern input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider-modern {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #cbd5e1;
  transition: 0.4s;
  border-radius: 14px;
  border: 1.5px solid #cbd5e1;
  display: flex;
  align-items: center;
  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.1);
}

.slider-modern .slider-thumb {
  position: absolute;
  left: 3px;
  top: 4px;
  width: 20px;
  height: 20px;
  background: #e5e7eb;
  border-radius: 50%;
  transition: 0.4s;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  transform: translateX(0);
}

.switch-modern input:checked + .slider-modern {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
}

.switch-modern input:checked + .slider-modern .slider-thumb {
  transform: translateX(30px);
}

.switch-modern input:checked + .slider-modern .thumb-icon {
  color: #10b981;
}

.switch-modern input:disabled + .slider-modern {
  opacity: 0.5;
  cursor: not-allowed;
}

.thumb-icon {
  color: #fff;
  font-size: 14px;
  transition: color 0.3s;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .switch-section {
    min-width: 100%;
    padding: 16px 10px;
  }
  .switch-header {
    font-size: 15px;
  }
}

@media (max-width: 480px) {
  .switch-section {
    padding: 12px 4px;
  }
  .switch-header {
    font-size: 14px;
  }
}
</style>